import data from "../../../../../src/Pagination/Pagination.docs.json";
import State from "../../../../components/State";
import * as React from 'react';
export default {
  data,
  State,
  React
};